export const STATE_KEY_SHOW_MODAL = 'showModal';
export const STATE_KEY_SHOW_POPOUT = 'showPopout';
export const STATE_KEY_BLOCK_FORWARD_NAVIGATION = 'blockForward';
export const NAVIGATION_BLOCKER_KEY = 'vk-mini-app-navigation-block';

export const SEARCH_PARAM_INFLATE = 'inflate';

export const UNIVERSAL_URL = '*';

export const DEFAULT_PATH_PARAM_NAME = 'path';
